<div class="container-fluid w-100">
  <div class="row h-100">
    <div class="col-12 col-sm-5 col-md-5 col-lg-4 bg-warning">
      <div class="px-1 py-3 px-lg-3 text-sm-right text-white top-25 position-relative">
        <h2 class="title mt-2 mt-lg-4">ERA</h2>
        <p class="mt-2 mt-lg-4"
           i18n>Your account has insufficient access rights to view this page.</p>
      </div>
    </div>
    <div class="col-12 col-sm-7 col-md-5 col-lg-4 align-self-top align-self-lg-stretch sidebar h-100">
      <div class="px-1 py-3 px-lg-3 text-start top-25 position-relative">
        <h3 class="title text-warning mt-2 mt-lg-4"
            i18n>Unauthorized</h3>
        <p>Insert message here</p>
      </div>
    </div>
  </div>
</div>